import { QEncodeChar } from "./QEncodeChar";

export function QEncode(str) {
  if (typeof str != "string") return str;

  var n = str.length;
  var encodeStr = "";
  for (var i = 0; i < n; i++) {
    var c = str[i];
    c = QEncodeChar(c);
    encodeStr += c;
  }

  return encodeStr;
}
